angular.module('bribac.services.newMessageEditorModal', [
  'ui.bootstrap',
  'bribac.components.messageEditorModal'
])

  .factory('newMessageEditorModal', function(
    $uibModal
  ) {
    return function(subject, saveSuccessCallback) {
      return $uibModal.open({
        component: 'messageEditorModal',
        resolve: {
          subject: subject,
          // Pass the callbacks inside an object because otherwise Angular will
          // thinks their arguments are dependencies that it should inject.
          callbacks: {
            // Pass a success callback that can be called immediately when the API
            // response is resolved, instead of using `$uibModal.open().result.then()`
            // which is called when the modal is closed.
            onSaveSuccess: saveSuccessCallback || angular.noop
          }
        },
        backdrop: 'static'
      })
    }
  })
